// removed by extract-text-webpack-plugin
module.exports = {"checkbox_section":"_3rhjUvYXgS2_6v8MqRcedp","checkbox_wrapper":"_1G5tt1RJsCnHXR1Lxm_vDr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LecturePage/lecture-type-checkbox.scss
// module id = 1335
// module chunks = 0